import { Box, Button, DialogActions, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DefaultModal from '../../components/Modals/DefaultModal';
import { CREATE_INVOICES } from '../../router/constants';
import SelectProjectModal from './SelectProjectModal';

interface Props {
  open: boolean;
  closeModal: () => void;
}

const CreateInvoiceModal = (props: Props): JSX.Element => {
  const navigate = useNavigate();
  const [openSelectProjectModal, setOpenSelectProjectModal] =
    useState<boolean>(false);

  return (
    <>
      <DefaultModal open={props.open} handleClose={() => props.closeModal()}>
        <Box sx={{ px: 6 }}>
          <Typography variant="h4" textAlign="center" color="grey.900" mb={2}>
            Create Invoice
          </Typography>
        </Box>
        <Box sx={{ px: 6 }}>
          <Typography
            variant="body1"
            textAlign="center"
            color="grey.900"
            mb={2}
          >
            It looks like you have open projects in the AllWork system. Do you
            want to create a new invoice against one of these project?
          </Typography>
        </Box>
        <DialogActions sx={{ justifyContent: 'center', pb: 3, gap: 2 }}>
          <Button
            onClick={() => navigate(CREATE_INVOICES)}
            variant={'outlined'}
            sx={{ width: 100 }}
          >
            No
          </Button>
          <Button
            onClick={() => setOpenSelectProjectModal(true)}
            sx={{ width: 100 }}
          >
            Yes
          </Button>
        </DialogActions>
      </DefaultModal>
      <SelectProjectModal
        opened={openSelectProjectModal}
        closeModal={() => {
          setOpenSelectProjectModal(false);
        }}
      />
    </>
  );
};

export default CreateInvoiceModal;
